// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import Tooltip_comp from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import {Text} from '@pub/comp/text';
import * as cns from './tooltip.module.less';
import './animation.less';

export const ANIMATION = {
    ZOOM: 'zoom',
    NOPE: 'nope',
};

const TRIGGERS = ['hover'];
const CLASSNAMES = {root: cns.root, body: cns.inner};
const DELAY_SEC = 0.2;
const ANIMATION_META = {
    [ANIMATION.ZOOM]: {motionName: 'sdk-tooltip-zoom'},
};
const PLACEMENT_ALIGN_MAP = {
    top: {points: ['bc', 'tc'], offset: [0, -6]},
    bottom: {points: ['tc', 'bc'], offset: [0, 6]},
    left: {points: ['cr', 'cl'], offset: [-6, 0]},
    right: {points: ['cl', 'cr'], offset: [6, 0]},
};

export function Tooltip({
    tip,
    children,
    trigger=TRIGGERS,
    placement='bottom',
    show_delay_s=DELAY_SEC,
    hide_delay_s=DELAY_SEC,
    animation=ANIMATION.ZOOM,
    classnames=CLASSNAMES,
    destroyOnHide=false,
})
{
    if (!tip)
        return children;
    const content = typeof tip=='string' ? <Text.xs>{tip}</Text.xs> : tip;
    return <Tooltip_comp classNames={classnames}
      trigger={trigger} overlay={content} destroyOnClose showArrow={false}
      mouseEnterDelay={show_delay_s} motion={ANIMATION_META[animation]}
      mouseLeaveDelay={hide_delay_s} align={PLACEMENT_ALIGN_MAP[placement]}
      destroyTooltipOnHide={destroyOnHide}>
      {children}
    </Tooltip_comp>;
}
